var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoTournamentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 3H9c0 1.075.121 2.455.359 4h-6.36v1c0 2.051.635 4.775 2.334 7.011 1.593 2.096 4.084 3.71 7.696 3.957 1.464 2.863 3.314 5.113 5.527 5.808L17 31v2h-3.25A1.75 1.75 0 0012 34.75V37h16v-2.25A1.75 1.75 0 0026.25 33H23v-2l-1.556-6.224c2.213-.695 4.063-2.945 5.528-5.808 3.61-.246 6.102-1.86 7.694-3.957C36.366 12.775 37 10.051 37 8V7h-6.358C30.88 5.455 31 4.075 31 3zM5.058 9h4.658c.512 2.535 1.295 5.317 2.336 7.84-2.41-.418-4.041-1.61-5.126-3.039C5.796 12.314 5.229 10.53 5.058 9zm25.227 0c-.512 2.535-1.295 5.317-2.337 7.84 2.41-.419 4.04-1.61 5.126-3.039 1.13-1.487 1.696-3.272 1.868-4.801h-4.657zM20 6a5 5 0 100 10 5 5 0 000-10zm-7 5a7 7 0 1114 0 7 7 0 01-14 0zm6.8-4.5L19 8.1v3.6l2.4 2.4 1.6.4-.4-1.6-2-2V8.1l-.8-1.6z",
    fill: "#9A9CAC"
  })));
}

export default SvgNoTournamentIcon;